import React from 'react';
import { useTranslation } from 'react-i18next';

import AddProperty from '@/modules/settings/company/components/Properties/Modals/AddProperty';
import { Typography } from '@/shared/components/atoms';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';
import List from '@/shared/components/molecules/ChooseAsset/List';
import { EntityType } from '@/shared/constant/enums';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import AddSquare from '~/images/shared/AddSquare.svg';

export default function TabsContent({
  activeKey,
  defaultAsset,
  setselectedAsset,
}: {
  activeKey: number;
  defaultAsset?: AssetItemProps;
  setselectedAsset: (val: AssetItemProps) => void;
}) {
  const { t } = useTranslation();

  // TODO: cache data
  // TODO: global state
  const [store] = useStore((store) => store);
  const assetsList = store?.assetsList;
  const isDemoFarm = store?.isDemoFarm;

  const { openModal } = useModal();

  return (
    <div className='flex w-full flex-col gap-16 bg-white py-16'>
      <div
        className='flex cursor-pointer items-center gap-8 p-9'
        onClick={() =>
          isDemoFarm
            ? openModal(<DemoCTA />)
            : openModal(<AddProperty />, {
                title: t('Add Property'),
                containerClassName: 'max-h-580 scrollbar',
              })
        }
      >
        <AddSquare width='24' height='24' />
        <Typography variant='subtitle2' className='text-text-default'>
          {t('Add Property')}
        </Typography>
      </div>
      {assetsList && (
        <List
          activeKey={activeKey}
          list={
            activeKey === EntityType.FARM
              ? assetsList.farms
              : assetsList.packhouses
          }
          selectedAsset={defaultAsset}
          setselectedAsset={setselectedAsset}
        />
      )}
    </div>
  );
}
